import { useEffect, useState } from "react";
import Slider from "@material-ui/core/Slider";
import Cropper from "react-easy-crop";
import { Point, Area } from "react-easy-crop/types";
import useStyles from "../../data/forms/forms-styles";

export enum ImageType {
	AVATAR,
	SIGNATURE,
}

interface ImageEditProps {
	path: string;
	imageType: ImageType;
	onCropComplete: (croppedArea: Area, croppedAreaPixels: any) => void;
	hasCropChanged?: (hasChanged: boolean) => void;
}

const ImageEdit = ({ path, onCropComplete, imageType, hasCropChanged }: ImageEditProps) => {
	const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
	const [zoom, setZoom] = useState(2);
	const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
	const classes = useStyles();
	const maxAvatarSize = 340;

	useEffect(() => {
		const img = new Image();
		img.src = path;
		img.onload = () => {
			setImageDimensions({ height: img.height, width: img.width });
		};
	}, []);

	const getMediaSize = (dimension: string) => {
		if (dimension === "width") {
			return imageDimensions.width >= imageDimensions.height ? maxAvatarSize : "";
		}
		return imageDimensions.height > imageDimensions.width ? maxAvatarSize : "";
	};

	return (
		<>
			<div className={classes.cropContainer}>
				<Cropper
					image={path}
					crop={crop}
					cropSize={
						imageType === ImageType.AVATAR
							? { width: maxAvatarSize, height: maxAvatarSize }
							: { width: imageDimensions.width, height: imageDimensions.height }
					}
					style={{
						cropAreaStyle: {
							top: "43%",
						},
						mediaStyle: {
							width: imageType === ImageType.AVATAR ? getMediaSize("width") : imageDimensions.width,
							height: imageType === ImageType.AVATAR ? getMediaSize("height") : imageDimensions.height,
							bottom: "14%",
						},
					}}
					cropShape={imageType === ImageType.AVATAR ? "round" : "rect"}
					zoom={zoom}
					aspect={imageType === ImageType.AVATAR ? 1 : 4 / 3}
					showGrid={false}
					onCropChange={setCrop}
					onCropComplete={onCropComplete}
					onZoomChange={setZoom}
				/>
			</div>
			<div className={classes.cropControls}>
				<Slider
					value={zoom}
					min={imageType === ImageType.AVATAR ? 1 : 0.5}
					max={3}
					step={0.1}
					aria-labelledby="Zoom"
					onChange={(_e, zoomScale) => {
						hasCropChanged && hasCropChanged(true);
						setZoom(Number(zoomScale));
					}}
					classes={{ root: classes.slider }}
				/>
			</div>
		</>
	);
};

export default ImageEdit;
